var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-list");
/**
 * The `List` component creates an unstyled ordered or unordered list that
 * should be used with the `ListItem`, `ListItemLink`, and `SimpleListItem`
 * components.
 */
var List = forwardRef(function List(_a, ref) {
    var _b = _a.role, role = _b === void 0 ? "none" : _b, _c = _a.dense, dense = _c === void 0 ? false : _c, _d = _a.ordered, ordered = _d === void 0 ? false : _d, _e = _a.horizontal, horizontal = _e === void 0 ? false : _e, className = _a.className, children = _a.children, props = __rest(_a, ["role", "dense", "ordered", "horizontal", "className", "children"]);
    var Component = (ordered ? "ol" : "ul");
    return (React.createElement(Component, __assign({}, props, { ref: ref, role: role, className: cn(block({ dense: dense, horizontal: horizontal }), className) }), children));
});
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        List.propTypes = {
            role: PropTypes.string,
            dense: PropTypes.bool,
            ordered: PropTypes.bool,
            className: PropTypes.string,
            children: PropTypes.node,
            horizontal: PropTypes.bool,
        };
    }
    catch (e) { }
}
export default List;
//# sourceMappingURL=List.js.map